import React, {useEffect, useState} from 'react'
import axios from 'axios'
import LoadingOverlay from 'react-loading-overlay'
import './PerfilVendedor.css'

const emptyPasswords = {currentPassword: '', newPassword: '', confirmPassword: ''}

function PerfilVendedor() {
  const API_URL = process.env.REACT_APP_API_URL
  const [profile, setProfile] = useState(null)
  const [passwords, setPasswords] = useState(emptyPasswords)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState(null)

  useEffect(() => {
    axios.get(`${API_URL}/perfil-vendedor`).then(({data}) => setProfile(data.data)).catch((error) => setMessage({type: 'danger', text: error.response?.data?.message || 'No fue posible cargar tu perfil.'})).finally(() => setLoading(false))
  }, [API_URL])

  const submit = async (event) => {
    event.preventDefault(); setMessage(null)
    if (passwords.newPassword !== passwords.confirmPassword) { setMessage({type: 'danger', text: 'Las contraseñas no coinciden.'}); return }
    setSaving(true)
    try {
      const {data} = await axios.put(`${API_URL}/perfil-vendedor-password`, passwords)
      setPasswords(emptyPasswords); setMessage({type: 'success', text: data.message})
    } catch (error) { setMessage({type: 'danger', text: error.response?.data?.message || 'No fue posible actualizar la contraseña.'}) }
    finally { setSaving(false) }
  }

  return <LoadingOverlay active={loading} spinner text='Cargando perfil...'><div className='perfil-vendedor'>
    <header><h1>Mi Perfil</h1><p>Consulta tus datos registrados.</p></header>
    <section><h2>Información general</h2><div className='perfil-vendedor-grid'>
      {[['Clave', profile?.clave], ['Nombre', profile?.nombre], ['Correo electrónico', profile?.email]].map(([label, value]) => <div className='perfil-vendedor-field' key={label}><span>{label}</span><strong>{value || 'No disponible'}</strong></div>)}
    </div></section>
    <section><h2>Contraseña y seguridad</h2><form className='perfil-vendedor-grid' onSubmit={submit}>
      {[['Contraseña actual', 'currentPassword', 'current-password'], ['Nueva contraseña', 'newPassword', 'new-password'], ['Confirmar contraseña', 'confirmPassword', 'new-password']].map(([label, name, complete]) => <label key={name}><span>{label}</span><input className='form-control' type='password' name={name} autoComplete={complete} minLength={name === 'currentPassword' ? undefined : 8} required value={passwords[name]} onChange={(event) => {setPasswords({...passwords, [name]: event.target.value}); setMessage(null)}} /></label>)}
      {message && <div className={`alert alert-${message.type} perfil-vendedor-message`}>{message.text}</div>}
      <div className='perfil-vendedor-actions'><button type='submit' className='btn btn-primary' disabled={saving}>{saving ? 'Guardando...' : 'Actualizar contraseña'}</button></div>
    </form></section>
  </div></LoadingOverlay>
}

export {PerfilVendedor}
